import cookieUtils from 'utils/Cookies';

function isRCPSCCAP() {
    const { isCCAPEnabled = false } = Sephora.configurationSettings;
    const isRCPSCCAPEnabled = cookieUtils.isRCPSCCAPEnabled();

    return isCCAPEnabled && isRCPSCCAPEnabled;
}

function isRCPSRwdBasketPersonalizationEnabled() {
    const { isBasketPersonalizationEnabled = false } = Sephora.configurationSettings;

    return isBasketPersonalizationEnabled;
}

function isRCPSAuthEnabled() {
    const { isNewAuthEnabled = false } = Sephora.configurationSettings;

    return isNewAuthEnabled;
}

function isRCPSBeautyChat() {
    return cookieUtils.isRCPSBeautyChat();
}

function isRCPSBeautyChatCA() {
    return cookieUtils.isRCPSBeautyChatCA();
}

function isRCPSCookieBasedAuthEnabled() {
    return Sephora.configurationSettings?.cookieBasedAuth?.isEnabled || false;
}

export default {
    isRCPSCCAP,
    isRCPSRwdBasketPersonalizationEnabled,
    isRCPSAuthEnabled,
    isRCPSBeautyChat,
    isRCPSBeautyChatCA,
    isRCPSCookieBasedAuthEnabled
};
